module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-grid-medium uk-child-width-1-1",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('shop-products', {
    attrs: {
      "shop-items": _vm.page.ShopItems,
      "shop-item-prices": _vm.page.ShopItemPrices,
      "shop-order-items": _vm.page.ShopOrderItems
    },
    on: {
      "load-page": _vm.loadPage,
      "buy-shop-item": _vm.buy
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "show": true,
      "label": ""
    }
  }, [_c('template', {
    slot: "loading-spinner"
  }, [_c('div', {
    attrs: {
      "uk-spinner": "ratio: 2"
    }
  })])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ebde56","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Search/SearchShopItems.vue
// module id = 119
// module chunks = 0